import React from "react";
import { Container } from "@mui/material";
import { Page } from "~/layout";
import { UserEditForm } from "./user-edit-form";

export function UserEditPage({
  navigation,
  breadcrumbs,
}: {
  navigation: React.ReactNode;
  breadcrumbs?: React.ReactNode;
}) {
  return (
    <Page title="Edit User" navigation={navigation}>
      <Container fixed>
        {breadcrumbs}
        <UserEditForm />
      </Container>
    </Page>
  );
}
